import { colors } from '@omilia/theme';
import React from 'react';
import { MessageStatus, MimeTypes } from 'types';
import {
  CsvFileAccentIcon,
  CsvFileIcon,
  DocFileAccentIcon,
  DocFileIcon,
  FileIcon,
  JpegFileAccentIcon,
  JpegFileIcon,
  JpgFileAccentIcon,
  JpgFileIcon,
  JsonFileAccentIcon,
  JsonFileIcon,
  PdfFileAccentIcon,
  PdfFileIcon,
  PngFileAccentIcon,
  PngFileIcon,
  TxtFileAccentIcon,
  TxtFileIcon,
} from '@omilia/icon';
import { SFileIcon } from '../FilePreview.styled';

export const AttachmentIcon = ({
  fileType,
  status,
}: {
  fileType: string;
  status: MessageStatus;
}) => {
  const getIcon = () => {
    const isPending = status === MessageStatus.PENDING;

    switch (fileType) {
      case MimeTypes.PDF:
        return isPending ? PdfFileIcon : PdfFileAccentIcon;
      case MimeTypes.JPEG:
        return isPending ? JpegFileIcon : JpegFileAccentIcon;
      case MimeTypes.JPG:
        return isPending ? JpgFileIcon : JpgFileAccentIcon;
      case MimeTypes.PNG:
        return isPending ? PngFileIcon : PngFileAccentIcon;
      case MimeTypes.DOC:
        return isPending ? DocFileIcon : DocFileAccentIcon;
      case MimeTypes.TXT:
        return isPending ? TxtFileIcon : TxtFileAccentIcon;
      case MimeTypes.CSV:
        return isPending ? CsvFileIcon : CsvFileAccentIcon;
      case MimeTypes.JSON:
        return isPending ? JsonFileIcon : JsonFileAccentIcon;
      default:
        return FileIcon;
    }
  };

  const getColor = () => {
    switch (fileType) {
      case MimeTypes.PDF:
        return colors.COLOR_RED_800;
      case MimeTypes.JPEG:
        return colors.COLOR_CYAN_700;
      case MimeTypes.DOC:
        return colors.COLOR_BLUE_500;
      default:
        return status === MessageStatus.ERROR
          ? colors.COLOR_RED_800
          : colors.COLOR_GREY_800;
    }
  };
  return <SFileIcon as={getIcon()} primaryColor={getColor()} size="20" />;
};
